import fixWebmDuration from 'webm-duration-fix';

/**
 * MediaRecorder WebM files omit Duration/Cues, so browsers only seek within
 * whatever they have already decoded. Remux the blob to inject that metadata.
 */
export async function makeWebmSeekable(blob: Blob): Promise<Blob> {
  try {
    return await fixWebmDuration(blob);
  } catch {
    return blob;
  }
}
